module.exports = __webpack_public_path__ + "static/media/roomConnecting.d1fb4704.png";